module.exports = __webpack_public_path__ + "front/img/27_3.3a9336dc.png";